import { PersonCreate } from "@boark/shared/types/person-create";
import { PersonUpdate } from "@boark/shared/types/person-update";
import {
  PersonWithHoldingsAndLeasesAndSubletsAndApartment,
  personWithHoldingsAndLeasesAndSubletsAndApartmentSchema,
} from "@boark/shared/types/person-with-holdings-and-leases-and-sublets-and-apartment";
import * as z from "zod";

import {
  deleteRequest,
  getRequest,
  postRequest,
  putRequest,
} from "../utils/request";

const API_BASE_URL = process.env.API_BASE_URL || "/api";

export async function getPersons(): Promise<
  PersonWithHoldingsAndLeasesAndSubletsAndApartment[]
> {
  return await getRequest(
    `${API_BASE_URL}/person`,
    z.array(personWithHoldingsAndLeasesAndSubletsAndApartmentSchema),
  );
}

export async function getPerson(
  id: string,
): Promise<PersonWithHoldingsAndLeasesAndSubletsAndApartment> {
  return await getRequest(
    `${API_BASE_URL}/person/${id}`,
    personWithHoldingsAndLeasesAndSubletsAndApartmentSchema,
  );
}

export async function createPerson(
  person: PersonCreate,
): Promise<PersonWithHoldingsAndLeasesAndSubletsAndApartment> {
  return await postRequest(
    `${API_BASE_URL}/person`,
    person,
    personWithHoldingsAndLeasesAndSubletsAndApartmentSchema,
  );
}

export async function updatePerson(
  id: string,
  person: PersonUpdate,
): Promise<PersonWithHoldingsAndLeasesAndSubletsAndApartment> {
  return await putRequest(
    `${API_BASE_URL}/person/${id}`,
    person,
    personWithHoldingsAndLeasesAndSubletsAndApartmentSchema,
  );
}

export async function deletePerson(id: string): Promise<void> {
  return await deleteRequest(`${API_BASE_URL}/person/${id}`);
}

export function formatPersonLabel(
  person: PersonWithHoldingsAndLeasesAndSubletsAndApartment,
): string {
  return `${formatName({
    firstName: person.firstName,
    lastName: person.lastName,
  })} (${formatPersonalIdentificationNumber(person.personalIdentificationNumber)})`;
}

function formatName({
  firstName,
  lastName,
}: {
  firstName?: string;
  lastName?: string;
}): string {
  if (!firstName && !lastName) {
    return "-";
  } else if (!firstName && lastName) {
    return lastName;
  }
  return `${firstName} ${lastName}`;
}

function formatPersonalIdentificationNumber(
  personalIdentificationNumber: string,
): string {
  return personalIdentificationNumber.replace(/^\d{2}(\d{6}).+$/, "$1-xxxx");
}
